<template>
    <el-card shadow="never" class="aui-card--fill">
        <div>
            <csbaseShow v-show="csbaseShow" :message="courseCode"  @onShowModer="vOnShowModer" @onCourseCode="vOnCourseCode" />
            <csconditionShow v-show="csconditionShow" :message="courseCode" @onShowModer="vOnShowModer" />
            <cspriceShow v-show="cspriceShow" :message="courseCode" @onShowModer="vOnShowModer" />
            <csrptShow v-show="csrptShow" :message="courseCode" @onShowModer="vOnShowModer" />
            <csinvestShow v-show="csinvestShow" :message="courseCode" @onShowModer="vOnShowModer" />
            <csabilityShow v-show="csabilityShow" :message="courseCode" @onShowModer="vOnShowModer" />
        </div>
    </el-card>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

import csbaseShow from './csbase/csbaseShow'// 基本信息
import csconditionShow from './cscondition/csconditionShow'// 报名条件
import cspriceShow from './csprice/cspriceShow'// 价格相关
import csrptShow from './csrpt/csrptShow'// 报表相关
import csinvestShow from './csinvest/csinvestShow'// 调查问卷
import csabilityShow from './csability/csabilityShow'// 能力项设置

export default {
// import引入的组件需要注入到对象中才能使用
  components: {
    csbaseShow,
    csconditionShow,
    cspriceShow,
    csrptShow,
    csinvestShow,
    csabilityShow
  },
  data () {
    return {
        inServForm: {
            offeringId: '',
            courseId: '',
            coursePrice: '',
            rewardScore: '',
            noShowPenalty: '',
            consumptionScore: '',
            budgetLine: '',
            offeringRevokePenaltyList: []
        },
      // 是否显示
      csbaseShow: true,
      csconditionShow: false,
      cspriceShow: false,
      csrptShow: false,
      csabilityShow: false,
      csinvestShow: false,
      courseCode: ''
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    console.log('created')
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.$eventHub.$on('showViewCourse', (data) => {
      console.log("sdfsdfsddsdsfd"+data)
      this.csbaseShow = true
      this.csconditionShow = false
      this.cspriceShow = false
      this.csrptShow = false
      this.csabilityShow = false
      this.csinvestShow = false
    })
  },
  beforeCreate () {
    console.log('beforeCreate')
  }, // 生命周期 - 创建之前
  beforeMount () {
    console.log('beforeMount')
  }, // 生命周期 - 挂载之前
  beforeUpdate () {
    console.log('beforeUpdate')
  }, // 生命周期 - 更新之前
  updated () {
    console.log('updated')
  }, // 生命周期 - 更新之后
  beforeDestroy () {
    console.log('beforeDestroy')
  }, // 生命周期 - 销毁之前
  destroyed () {
    console.log('destroyed')
  }, // 生命周期 - 销毁完成
  activated () {
    console.log('activated')
  },


  provide () {
    return {
      toTop: this.toTop
    }
  },
  // 方法集合
  methods: {
    // 回到顶部
    toTop: function () {
      window.scrollTo(0, 0)
    },
    vOnCourseCode: function (courseCode) {
      this.courseCode = courseCode
    },
    // 判断哪个页面显示
    vOnShowModer: function (childValue) {
      switch (childValue) {
        // 点击圈圈
        case 'csbaseShow':
          this.onCsbaseShow()
          break
        case 'csconditionShow':
          this.onCsconditionShow()
          break
        case 'cspriceShow':
          this.onCspriceShow()
          break
        case 'csrptShow':
          this.onCsrptShow()
          break
        case 'csinvestShow':
          this.onCsinvestShow()
          break
        case 'csabilityShow':
          this.onCsabilityShow()
          break
        default:
              // text = '期待周末~'
      }
    },
    onCsbaseShow: function (childValue) {
      this.csbaseShow = true
      this.csconditionShow = false
      this.cspriceShow = false
      this.csrptShow = false
      this.csabilityShow = false
      this.csinvestShow = false
    },
    onCsconditionShow: function (childValue) {
      this.csbaseShow = false
      this.csconditionShow = true
      this.cspriceShow = false
      this.csrptShow = false
      this.csabilityShow = false
      this.csinvestShow = false
    },
    onCspriceShow: function (childValue) {
      this.csbaseShow = false
      this.csconditionShow = false
      this.cspriceShow = true
      this.csrptShow = false
      this.csabilityShow = false
      this.csinvestShow = false
    },
    onCsrptShow: function (childValue) {
      this.csbaseShow = false
      this.csconditionShow = false
      this.cspriceShow = false
      this.csrptShow = true
      this.csabilityShow = false
      this.csinvestShow = false
    },
    onCsinvestShow: function (childValue) {
      this.csbaseShow = false
      this.csconditionShow = false
      this.cspriceShow = false
      this.csrptShow = false
      this.csabilityShow = false
      this.csinvestShow = true
    },
    onCsabilityShow: function (childValue) {
      this.csbaseShow = false
      this.csconditionShow = false
      this.cspriceShow = false
      this.csrptShow = false
      this.csabilityShow = true
      this.csinvestShow = false
    }
  }
}
</script>
<style lang='scss' scoped >

</style>
